// Get all game positions depend on spot
export const getAllPlayers = (spotId, librariesResponse) =>
	librariesResponse &&
	librariesResponse.libraries
		.map((item) => item.spots)
		.flat()
		.find((item) => item.spot_id === spotId).all_positions

export const getEnablePlayers = (spotId, librariesResponse) =>
	librariesResponse &&
	librariesResponse.libraries
		.map((item) => item.spots)
		.flat()
		.find((item) => item.spot_id === spotId).spot_positions

// Get lib name from get_libraries
export const getLib = (spotId, librariesResponse) =>
	spotId &&
	librariesResponse &&
	librariesResponse.libraries.find((el) => el.spots.find((s) => s.spot_id === spotId)).library_name

// Get eff Stack
export const getEffStack = (query) => query?.split('_')[0]

// Get players array depends on spotName
export function trainerPositions(librariesResponse) {
	const obj = {}
	librariesResponse &&
		librariesResponse.libraries.map((el) => el.spots.map((s) => (obj[s.spot.replace(/\s/g, '')] = s.spot_positions)))

	return obj
}

// Get spotName
export const getSpotName = (libraries, spotId, playersArray) => {
	if (!playersArray || !libraries) return ''
	const spotsMapper = {}
	libraries.forEach((item) => item.spots.forEach((spot) => (spotsMapper[spot.spot_id] = spot.spot)))

	return [spotsMapper[spotId], playersArray[spotsMapper[spotId].replace(/\s/g, '')]]
}

// Replacer space from spotName
export const spotNameNoSpace = (spot) => spot.replace(/\s+/g, '')

// Get Players action struct for trainer
export const getPlayersAction = (allPlayers) => {
	const obj = {}
	allPlayers.map(
		(el) =>
			(obj[el] = obj[el] =
				{
					action: '',
					isActionDone: false,
					stake: null,
				})
	)

	return obj
}

// Get players full info block for trainer
export const getPlayersFull = (allPlayers) => {
	const obj = {}
	allPlayers.map(
		(el, index) =>
			(obj[el] = obj[el] =
				{
					active: false,
					range: null,
					hand: '',
					handIndex: null,
					actions: {},
					initBet: null,
					startBet: 0,
					isDealer: false,
					stack: null,
					isFold: false,
					is_bet: false,
					endStack: null,
					index: index,
				})
	)

	return obj
}

// Get players full info block for trainer
export const getPlayersActions = (allPlayers) => {
	const obj = {}
	allPlayers.map(
		(el) =>
			(obj[el] = obj[el] =
				{
					active: false,
					actions: [],
					isFold: false,
				})
	)

	return obj
}

// Deep array of objects copy
export const deepCopy = (arr) => {
	const out = []
	for (let i = 0, len = arr.length; i < len; i++) {
		const item = arr[i]
		const obj = {}
		for (const k in item) {
			if (typeof obj[k] === 'object') {
				obj[k] = deepCopy(item[k])
			} else {
				obj[k] = item[k]
			}
		}
		out.push(obj)
	}

	return out
}

export const getQueryWithBet = (query) => {
	const flopIndex = query.indexOf('_F.') !== -1 ? query.indexOf('_F.') : query.length + 1
	const turnIndex = query.indexOf('_T.') !== -1 ? query.indexOf('_T.') : query.length + 1
	const riverIndex = query.indexOf('_R.') !== -1 ? query.indexOf('_R.') : query.length + 1

	const preflopStreet = query.slice(0, flopIndex).split('_').filter(Boolean)
	const flopStreet = query.slice(flopIndex, turnIndex).split('_').filter(Boolean)
	const turnStreet = query.slice(turnIndex, riverIndex).split('_').filter(Boolean)
	const riverStreet = query.slice(riverIndex).split('_').filter(Boolean)

	const flopBetIndex = flopStreet.findIndex((action) => action.includes('r'))
	const turnBetIndex = turnStreet.findIndex((action) => action.includes('r'))
	const riverBetIndex = riverStreet.findIndex((action) => action.includes('r'))

	const flopReplacedBet = flopStreet.map((action, index) =>
		flopBetIndex === index ? action.replace('r', 'b') : action
	)
	const turnReplacedBet = turnStreet.map((action, index) =>
		turnBetIndex === index ? action.replace('r', 'b') : action
	)
	const riverReplacedBet = riverStreet.map((action, index) =>
		riverBetIndex === index ? action.replace('r', 'b') : action
	)

	return [...preflopStreet, ...flopReplacedBet, ...turnReplacedBet, ...riverReplacedBet]
}

export const getHumanReadableQueryline = (query) => {
	if (!query) return ''
	// make sure we got string to make split method work
	query = String(query)
	const replacedQuery = getQueryWithBet(query)

	const mapper = {
		c: 'C',
		k: 'X',
		r: 'R',
		b: 'B',
		f: 'F',
	}

	return replacedQuery.reduce((acc, value) => {
		// if regular action
		if (mapper[value[2]]) {
			if (value[2] === 'r') return `${acc} ${value.toUpperCase().slice(2)}`

			return `${acc} ${mapper[value[2]]}`
		}
		// board action
		if (value[0] === 'F') return `${acc} FLOP`
		if (value[0] === 'T') return `${acc} TURN`
		if (value[0] === 'R') return `${acc} RIVER`

		return acc
	}, '')
}

export const getStartQueryTags = (startQuery) => {
	const tagStartQuery = getHumanReadableQueryline(startQuery)?.split(' ')

	const isFlop = tagStartQuery.includes('FLOP')
	const isTurn = tagStartQuery.includes('TURN')
	const isRiver = tagStartQuery.includes('RIVER')

	const preflopQuery = !isFlop
		? tagStartQuery.join(' ')
		: tagStartQuery.filter((_, index) => index < tagStartQuery.indexOf('FLOP')).join(' ')

	const flopQuery =
		isFlop && isTurn
			? tagStartQuery
					.filter((_, index) => index < tagStartQuery.indexOf('TURN') && index > tagStartQuery.indexOf('FLOP'))
					.join(' ')
			: isFlop && !isTurn
			? tagStartQuery.filter((_, index) => index > tagStartQuery.indexOf('FLOP')).join(' ')
			: ''

	const turnQuery =
		isTurn && isRiver
			? tagStartQuery
					.filter((_, index) => index < tagStartQuery.indexOf('RIVER') && index > tagStartQuery.indexOf('TURN'))
					.join(' ')
			: isTurn && !isRiver
			? tagStartQuery.filter((_, index) => index > tagStartQuery.indexOf('TURN')).join(' ')
			: ''

	const riverQuery = isRiver && tagStartQuery.filter((_, index) => index > tagStartQuery.indexOf('RIVER')).join(' ')

	return [
		{ name: 'preflop', query: preflopQuery ? preflopQuery : '' },
		{ name: 'flop', query: flopQuery ? flopQuery : '' },
		{ name: 'turn', query: turnQuery ? turnQuery : '' },
		{ name: 'river', query: riverQuery ? riverQuery : '' },
	]
}

export const getSwitchModePlayers = (arr, index = -1) => {
	let players = [...arr]

	return () => {
		const left = players.slice(0, index)
		const right = players.slice(index)
		index = 1
		players = [...right, ...left]

		return players
	}
}

export const getHeroHandIndex = (str, hand) => {
	// const str = getRangeFromAbs(range, eq, ev, combos)

	let idx
	for (let i = 0; i < 13; i += 1) {
		for (let j = 0; j < 13; j += 1) {
			const cards = str[i + 13 * j].c

			for (let k = 0; k < cards.length; k++) {
				const c = cards[k]
				if (hand && hand === c.index) {
					idx = c.index
				}
			}
		}
	}

	return idx
}

const getRangedArrayPoints = (sortedStr, heroHand, matrixThreshold) => {
	let i = 0
	let absMaxHero = 0.0
	let absMinHero = 0.0
	const rangedPoints = []
	const filteredCards = []

	sortedStr.forEach((el) => {
		if (el.s === heroHand) {
			filteredCards.push(el.s)
		}
	})

	const res = sortedStr.filter((item) => !filteredCards.includes(item.s))

	sortedStr.forEach((el) => {
		const isFiltered = res.some((h) => h.s === el.s)

		if (el.abs > matrixThreshold) {
			absMaxHero = el.eq > absMaxHero ? el.eq : absMaxHero
			absMinHero = el.eq < absMinHero ? el.eq : absMinHero
		}
	})

	sortedStr.forEach((el) => {
		const isFiltered = res.some((h) => h.s === el.s)

		if (el.abs > matrixThreshold) {
			i += el.abs

			rangedPoints.push({
				x: i - el.abs,
				y: el.eq,
				card: el.s,
				abs: el.abs,
				absMaxHero,
				absMinHero,
				opacity: isFiltered ? 0 : 1,
			})
		}
	})

	rangedPoints.forEach((c, i) => (rangedPoints[i].x = rangedPoints[i].x / rangedPoints[rangedPoints.length - 1].x))

	const foundHandPercent = rangedPoints.find((el) => el.opacity === 1)
		? rangedPoints.find((el) => el.opacity === 1).x === 0
			? 100
			: rangedPoints.find((el) => el.opacity === 1).x * 100
		: 0

	return { foundHandPercent, rangedPoints }
}

export const getPercentValuesMoreCurrent = ({ struct, heroHand, matrixThreshold }) => {
	const strStruct = struct
		.slice()
		.flatMap((el) => el.c)
		.sort((a, b) => a.eq - b.eq)

	const percent = getRangedArrayPoints(strStruct, heroHand, matrixThreshold)

	return percent
}

export const replaceFold = (arr) => {
	let count = 1
	let lastIndex = null

	const checkCount = (curr, index, arr) => {
		if (curr === arr[index + 1]) {
			count += 1
			lastIndex = index + 1

			checkCount(curr, index + 1, arr)
		}

		return count
	}

	return arr.map((curr, index, arr) => {
		if (curr === 'F') {
			if (lastIndex !== null && lastIndex >= index) {
				return ''
			}

			const countF = checkCount(curr, index, arr)
			count = 1

			return countF > 1 ? `Fx${countF}` : 'F'
		}

		return curr
	})
}

export const convertConfigFiltersToNormalFormat = (filters) => {
	const normalFormatFilters = {}

	for (const key in filters) {
		if (filters[key] === null) {
			normalFormatFilters[key] = ['Any']
		}

		if (Array.isArray(filters[key])) {
			normalFormatFilters[key] = filters[key]
		}
	}

	return normalFormatFilters
}

export const getAction = (actions, i) => {
	let action = ''

	if (actions.length - 1 < i || i < 0) {
		return null
	}

	if (typeof actions[i].action === 'string') {
		action = actions[i].action.toLowerCase() === 'check' ? 'X' : actions[i].isAllIn ? 'A' : actions[i].action[0]
	} else {
		action = actions[i].action.join('')
	}

	return action
}

export const replaceFoldInNode = (actions) => {
	let firstIndex = 0
	let lastIndex
	const updatedActions = []

	actions.forEach((action, index, array) => {
		if (action?.props.children.includes('F')) {
			if (!array?.[index - 1]?.props.children.includes('F')) {
				firstIndex = index ?? 0
			}

			if (!array?.[index + 1]?.props.children.includes('F')) {
				lastIndex = index
				const count = lastIndex - firstIndex + 1

				if (lastIndex === index) {
					const updatedAction = {
						...action?.props,
						children: count > 1 ? action?.props.children.concat(`${count}`) : 'F',
					}

					updatedActions.push({ ...action, props: updatedAction })
				}
			}
		} else {
			updatedActions.push(action)
		}
	})

	const count = actions.reduce((acc, action, index, arr) => {
		return acc + (action?.props.children.includes('F') ? 1 : 0)
	}, 0)

	return updatedActions
}

export const getSpotIndex = (librariesResponse, lib, isTrainer = false) => {
	const selectedSpot = localStorage.getItem('trainerSelectedSpot')

	const defaultIndex =
		lib === '6-Max Cash' && librariesResponse
			? librariesResponse.libraries.find((el) => el.library_name === lib).spots.findIndex((el) => el.spot_id === 119)
			: 0

	if (selectedSpot && librariesResponse && isTrainer) {
		const index = librariesResponse.libraries
			.find((el) => el.library_name === lib)
			.spots.findIndex((el) => el.spot_id === Number(selectedSpot))

		return index !== -1 ? index : defaultIndex
	}

	return defaultIndex
}
